import React, { useEffect, useState } from 'react';
import { fetchOnlineStats, OnlineStats } from '../../api/presence';
import { tr } from '../../i18n';

const REFRESH_INTERVAL_MS = 30_000;

const OnlineCounter: React.FC = () => {
  const [stats, setStats] = useState<OnlineStats | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      if (document.visibilityState !== 'visible') return;
      fetchOnlineStats()
        .then(result => { if (!cancelled) setStats(result); })
        .catch(() => undefined);
    };

    load();
    const timer = window.setInterval(load, REFRESH_INTERVAL_MS);
    document.addEventListener('visibilitychange', load);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', load);
    };
  }, []);

  if (!stats) return null;

  const title = tr.common.sidebar.onlineUsers(stats.authenticated, stats.guests);
  return (
    <span className="app-header-online-counter" title={title} aria-label={title}>
      <span className="app-header-online-counter-dot" aria-hidden="true" />
      <span className="app-header-online-counter-value">{stats.online}</span>
    </span>
  );
};

export default OnlineCounter;
